import { Injectable } from '@angular/core';
import create from './ngGuid';

@Injectable({
    providedIn: 'root'
})
export class UtilityService {
    isNullOrWhiteSpace(str: string | null | undefined): boolean {
        if (typeof str === 'undefined') {
            return true;
        }
        return str === null || str.trim() === '';
    }

    newGuid() {
        return create();
    }
}
